export interface FilterState {
    rising: boolean;
    new: boolean;
}

export type FilterAction = { type: "TOGGLE_FILTER"; payload: keyof FilterState };

export const initialFilters: FilterState = { rising: false, new: false };

export const filterReducer = (state: FilterState, action: FilterAction): FilterState => {
    if (action.type === "TOGGLE_FILTER") {
        return {
            ...state,
            [action.payload]: !state[action.payload],
            ...(action.payload === "rising" ? { new: false } : { rising: false }),
        };
    }
    return state;
};
